import MailIcon from "@mui/icons-material/MailOutlineRounded";
import PersonIcon from "@mui/icons-material/PersonOutlineRounded";
import { Avatar } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";
import type { InboxChannelType } from "../../../../api/types/inboxesTypes";

interface Props {
  channelType: InboxChannelType;
  size: number;
  color?: "primary" | "secondary" | "info";
}

const AgentInboxChannelTypeAvatar = ({ channelType, size, color }: Props) => {
  return (
    <Avatar
      variant="rounded"
      sx={(t) => ({
        height: size,
        width: size,
        bgcolor: color !== "secondary" ? makeTintedBackgroundFromColor(t, t.palette.primary.main) : undefined,
      })}
    >
      {channelType === "Email" && <MailIcon color={color ?? "secondary"} />}
      {channelType === "Api" && <PersonIcon color={color ?? "secondary"} />}
    </Avatar>
  );
};

export default AgentInboxChannelTypeAvatar;
